import React from 'react';

export default function HamburgerButton() {
  return (
    <button className="hamburger" aria-label="Open menu" aria-expanded="false">
      <img
        src="/imgs/menu-icon.png"
        alt=""
        className="hamburger-icon"
        width={46}
        height={46}
        decoding="async"
      />
    </button>
  );
}
